import { Grid2 } from "@mui/material";
import PropInput from "./PropInput";

const PropList = ({ id, props, propInfo, handlePropChange }) => {
  const handleChange = (prop, value) => {
    const updated = { ...props };
    updated[prop] = value;
    handlePropChange(updated);
  };

  return (
    <>
      {propInfo && (
        <Grid2 container spacing={2}>
          {propInfo.map((pI, index) => {
            return (
              <Grid2
                key={`${pI.value}-${index}`}
                size={12}
                sx={{ alignItems: "center" }}
              >
                <PropInput
                  name={pI.name}
                  pageId={id}
                  inputType={pI.type}
                  options={pI.options}
                  prop={props[pI.value]}
                  handleChange={(value) => handleChange(pI.value, value)}
                />
              </Grid2>
            );
          })}
        </Grid2>
      )}
    </>
  );
};

export default PropList;
